__turbopack_context__.v({
  "barToggleWrap": "audience-mega-menu-header-module__tLLKQa__barToggleWrap",
  "drawerSwitch": "audience-mega-menu-header-module__tLLKQa__drawerSwitch",
  "drawerSwitchBtn": "audience-mega-menu-header-module__tLLKQa__drawerSwitchBtn",
  "drawerTip": "audience-mega-menu-header-module__tLLKQa__drawerTip",
  "drawerToggleWrap": "audience-mega-menu-header-module__tLLKQa__drawerToggleWrap",
  "switch": "audience-mega-menu-header-module__tLLKQa__switch",
  "switchBtn": "audience-mega-menu-header-module__tLLKQa__switchBtn",
  "switchBtnOn": "audience-mega-menu-header-module__tLLKQa__switchBtnOn",
  "tip": "audience-mega-menu-header-module__tLLKQa__tip",
});
